export default "/_next/static/chunks/fonts/MaterialIcons.ttf";